import React from 'react';
import ExperiencePage from '../components/ExperiencePage';

const Flexcar = () => {
  return (
    <ExperiencePage
      company="Flexcar"
      role="Software Engineer"
      period="March 2023 - August 2023"
      description={[
        "Led 3 major releases for pricing model, checkout, and decoupling from parent company infrastructure",
        "Managed high priority cross-functional projects from senior leadership across multiple sprints",
        "Improved engineering culture by switching from large bi-weekly to continuous deployments across Flexcar"
      ]}
    />
  );
};

export default Flexcar;
